<template>
		<form-sidebar>
			<v-form method="post" @submit.prevent="submitForm">
				<v-layout wrap>
					<v-flex xs12 sm12 md12 lg12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Correo de Usuario"
							required
							v-model="$v.model.email.$model"
							:error="$v.model.email.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm12 md12 lg12>
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Código de Usuario"
							required
							v-model="$v.model.code.$model"
							:error="$v.model.code.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm12 md12 lg12 v-if="show">
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Contraseña"
							required
							type="password"
							v-model="$v.model.password.$model"
							:error="$v.model.password.$error"
						>
						</v-text-field>
					</v-flex>
					<v-flex xs12 sm12 md12 lg12 v-if="show">
						<v-text-field
							background-color="white"
							box
							class="body-1"
							hide-details
							label="Repetir Contraseña"
							required
							type="password"
							v-model="$v.model.repeatPassword.$model"
							:error="$v.model.repeatPassword.$error"
						>
						</v-text-field>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						:is-loading="$v.$invalid || loading"
						:on-run-service="loading"
						@accept-button-clicked="submitForm"
						@cancel-button-clicked="closeModal"
					/>
				</section>
			</v-form>
		</form-sidebar>
</template>

<script>
import { required, email, sameAs } from 'vuelidate/lib/validators';

function data() {
	return {
		countries: [],
		loading: false,
		model: {
			email: '',
			code: '',
			password: '',
			repeatPassword: '',
		},
	};
}

async function created() {
	if (this.mode === 'edit') {
		const { data: record } = await this.$http.get(`user/${this.userId}`);
		if (record.data) {
			this.model = {
				email: record.data.email,
				code: record.data.codeUser,
			};
		}
	}
}

function closeModal() {
	this.goTo('page-user');
}

function mode() {
	return this.userId ? 'edit' : 'create';
}

function show() {
	let showInput;
	if (this.userId) {
		showInput = false;
	} else {
		showInput = true;
	}
	return showInput;
}

async function submitForm() {
	const body = {
		codeProject: this.codeProject,
		email: this.model.email,
		password: this.model.password,
		codeUser: this.model.code,
		status: true,
		codeCompany: this.companyCode,
	};
	const method = this.mode === 'create' ? 'post' : 'put';
	const url = this.mode === 'create' ? 'user' : `user/${this.userId}`;
	const message = this.mode === 'create' ? 'creado' : 'editado';
	this.loading = true;
	try {
		await this.$http[method](url, body);
		this.showNotification(`Usuario ${message} correctamente.`);
		this.goTo('page-user');
	} catch (err) {
		this.showError();
	} finally {
		this.loading = false;
	}
}

function validations() {
	let validation = {};
	if (this.userId) {
		validation = {
			model: {
				email: {
					required,
					email,
				},
				code: {
					required,
				},
			},
		};
	} else {
		validation = {
			model: {
				email: {
					required,
					email,
				},
				code: {
					required,
				},
				password: {
					required,
				},
				repeatPassword: {
					required,
					sameAsPassword: sameAs('password'),
				},
			},
		};
	}
	return validation;
}

export default {
	name: 'projects-form',
	created,
	computed: {
		mode,
		show,
	},
	data,
	methods: {
		closeModal,
		submitForm,
	},
	props: {
		userId: {
			type: [Number, String],
		},
		codeProject: {
			type: String,
		},
		companyCode: {
			type: String,
		},
	},
	validations,
};
</script>



// WEBPACK FOOTER //
// src/components/users/user-new-form.vue